import axios from '../request/http.js'
import { handleGetRequestParams } from '../common/js/utils.js'

class Inventory {
  /* 库存列表 */
  static getInventoryList(canteenId, name, currentPage) {
    let url = `/zzd/api/back/storage/list?canteenId=${canteenId}&name=${name}&currentPage=${currentPage}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 领用 */
  static postClaim(data) {
    let url = `/zzd/api/back/storage/receive`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 采购记录 */
  static getPurchaseRecode(options) {
    let url = `/zzd/api/back/storage/purchase?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 消耗记录 */
  static getConsumptionRecode(options) {
    let url = `/zzd/api/back/storage/receive/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default Inventory